/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export enum SortFilter {
  UnitName = "UnitName",
  MonthlyCosts = "MonthlyCosts",
  PreviousMonthCosts = "PreviousMonthCosts",
  MonthlyForecastCosts = "MonthlyForecastCosts",
  MonthlyBudget = "MonthlyBudget",
  Environments = "Environments",
}

export const SELECT_OPTIONS = [
  {
    value: SortFilter.UnitName,
    label: "Organizational Unit Name",
  },
  {
    value: SortFilter.MonthlyCosts,
    label: "Monthly Costs",
  },
  {
    value: SortFilter.PreviousMonthCosts,
    label: "Previous Month Costs",
  },
  {
    value: SortFilter.MonthlyForecastCosts,
    label: "Monthly Forecast Costs",
  },
  {
    value: SortFilter.MonthlyBudget,
    label: "Monthly Budget",
  },
  {
    value: SortFilter.Environments,
    label: "Environments",
  },
];
